(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_blog-post-content"] && !Shopify.designMode) return;
  try {
    (() => {
    const init = (root) => {
      root.querySelectorAll('.bh-article-toc:not([data-toc-ready])').forEach((nav) => {
        nav.setAttribute('data-toc-ready', '');
        const article = nav.nextElementSibling;
        if (!article || !article.classList.contains('blog-post-content')) return;
        const headings = Array.from(article.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
        if (headings.length < 3) return;
        const used = new Set(Array.from(document.querySelectorAll('[id]')).map((el) => el.id));
        const list = nav.querySelector('ol');
        headings.slice(0, 24).forEach((heading, index) => {
          if (!heading.id) {
            const base = heading.textContent.trim().toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
            let id = 'article-' + base;
            let n = 2;
            while (used.has(id)) id = 'article-' + base + '-' + n++;
            heading.id = id;
          }
          used.add(heading.id);
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + encodeURIComponent(heading.id);
          link.textContent = heading.textContent.trim();
          item.appendChild(link);
          list.appendChild(item);
        });
        nav.hidden = false;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
    else init(document);
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
